define([
	"dojo/_base/declare",
	"csi/core/Key",
	"csi/heading/_base",
	"csi/heading/Renderer",
	"csi/xml",
	"csi/utility/pathUtility",
	"./_ValueAttributeMixin"
], function(declare, Key, csiHeading, Renderer, xml, {pathCreate}, _ValueAttributeMixin) {

	/** @property {Object} _valueMap - Maps value types to the optional attributes on the SpecificationDatasheetResponseItem */
	const _valueMap = {
		[xml.ATTR_REF]: "SpecValueLookupItem",
		[xml.ATTR_REFLIST]: "SpecValueLookupItemList",
		[xml.ATTR_BOOLEAN]: "SpecValueBoolean",
		[xml.ATTR_DOUBLE]: "SpecValueDouble",
		[xml.ATTR_INTEGER]: "SpecValueInt",
		[xml.ATTR_STRING]: "SpecValueString"
	};

	return declare([Renderer, _ValueAttributeMixin], {
		/**
		 * @override
		 * add dependency paths
		 */
		addRendererDependencyPaths(h, paths) {
			paths.push(pathCreate("SpecDefinition","ValueAttributeDefinition"));
			paths.push(pathCreate("SpecValueLookupItem"));
			paths.push(pathCreate("SpecValueLookupItemList"))
			this.inherited(arguments);
		 },

		/**
		 * @override
		 * Display different SpecValue attributes under single "Spec Value" column
		 */
		headingToHtml: function(ctx, h, refNode) {
			const vad = this._getValueAttributeNode(ctx);
			if (!vad) {
				return;
			}

			const id = _valueMap[vad.ValueType];
			const name = id + (vad.Format || "");
			const valueHeading = ctx.view.getHeading(new Key({
				id,
				name,
			}));

			csiHeading.getHeadingRenderer(ctx, valueHeading).headingToHtml(ctx, valueHeading, refNode);
		}
	});
});